import ApiService from '../api.service'
import { Abono } from './abono'
import { Afastamento } from './afastamentos'
import { LogCalculos } from './calculo'
import { CompensacaoManual } from './compensacao-manual'
import { DescontoDSRFuncionario, DSR } from './dsr'
import { Escalas } from './escalas'
import { FaltaCadastrada } from './faltas-cadastradas'
import { CompensacaoDia } from './feriados'
import { FeriadosCliente } from './feriados-cliente'
import { Registro } from './registros'
import { Sobreaviso } from './sobreaviso'
import { TabelaHorarios } from './tabela-horarios'
import { TrocaDiaTrabalho } from './troca-horarios'

export interface JornadaDiaria {
    id: number
    nome: string
    empresaId: number
    dia: string
    funcionarioId: number
    registros: Registro[]
    tabelaHorario?: TabelaHorarios[]
    isAtivo: boolean

    troca?: TrocaDiaTrabalho
    abono?: Abono
    afastamento?: Afastamento
    compensacao?: CompensacaoDia
    compensacaoManual?: CompensacaoManual
    sobreaviso?: Sobreaviso
    feriado?: FeriadosCliente
    DSR?: DSR
    trabalhaNoDia: boolean
    faltaCadastrada?: FaltaCadastrada
    folga?: any
    escala?: Escalas
    descontoDsr: DescontoDSRFuncionario
    logs?: LogCalculos[]

    horasExtra?: string
    horasTrabalhadas?: string
    faltas?: string
    /** Justificativa da edição manual do dia (feature #1522) */
    justificativa?: string | null
    /** Horas extras por porcentagem da regra de cálculo: { '50': '01:00' } */
    porcentagemHrsExtras?: Record<string, string>
}

type JornadaDiariaQuery = {
    empresaId: number
    dia: string
}

type JornadaDiariaQueryCentroCusto = JornadaDiariaQuery & {
    centroCustoId: number
    localId?: never
}

type JornadaDiariaQueryLocal = JornadaDiariaQuery & {
    localId: number
    centroCustoId?: never
}

export type JornadaDiariaQueryXor =
    | JornadaDiariaQuery
    | JornadaDiariaQueryCentroCusto
    | JornadaDiariaQueryLocal

export type JornadaMensal = Omit<JornadaDiaria, 'id' | 'nome' | 'empresaId'>
type JornadaMensalQuery =
    | {
          funcionarioId: number
          organizar: boolean
          competencia: string
      }
    | {
          funcionarioId: number
          organizar: boolean
          dataInicial: string
          dataFinal: string
      }

type JornadaMensalQueryCentroCusto = JornadaMensalQuery & {
    centroCustoId: number
    localId?: never
}

type JornadaMensalQueryLocal = JornadaMensalQuery & {
    localId: number
    centroCustoId?: never
}

export type JornadaMensalQueryXor =
    | JornadaMensalQuery
    | JornadaMensalQueryCentroCusto
    | JornadaMensalQueryLocal

export const jornada = {
    mensal: new ApiService<null, JornadaMensal, JornadaMensalQueryXor>(
        'jornada',
    ),
    diaria: new ApiService<null, JornadaDiaria, JornadaDiariaQueryXor>(
        'jornada',
    ),
}
